import React, { useState, useEffect, useCallback } from 'react';


//to load conditionally load in its only functional component:
// EXAMPLE:
// const LazyComponentSearch = ({location, nameofClass}) =>{
//     const LazyLoadSearch = useLazyLoadComponent(location, nameofClass)
//     return LazyLoadSearch
// }

const useLazyLoadComponent  = ( componentLocation, nameofClass='') => {
    const [ LazyComponent, setLazyComponent ] = useState(null)

    const loadLazyComponent = useCallback(async () => {
        if (LazyComponent !== null) {
          return
        }
    
        // import default export
        const { default: lazyModule} = await import(`./../components${componentLocation}`)
        // create React component
        const LazyElement = React.createElement(lazyModule, {
            nameOfClass: nameofClass
        })

        setLazyComponent(LazyElement)
    },[componentLocation, nameofClass, LazyComponent])

    useEffect(() => {
        if (LazyComponent === null) {
            loadLazyComponent()
          }
      return () => {
      }
    }, [loadLazyComponent, LazyComponent])

    return LazyComponent
}

export default useLazyLoadComponent